import React from "react";
import CategoryPage from "./CategoryPage";

const BikeVinylStickers = () => (
  <CategoryPage
    categoryId="bike-vinyl-stickers"
    categoryTitle="Bike Vinyl Stickers"
    categoryDescription="Premium vinyl stickers designed specifically for bikes. Weather-resistant, UV-protected, and available in multiple sizes and designs. Perfect for personalizing your motorcycle or bicycle."
  />
);

export default BikeVinylStickers;
